export const NAV_MENU_WIDTH = '260px'; // default width for top nav menu dropdown

export const NAV_DRAWER_WIDTH = '240px'; // default width for left anchored nav drawer
export const NAV_DRAWER_WIDTH_LARGE = '260px';
